
if (!customElements.get('custom-modal')) {
  customElements.define(
    'custom-modal',
    class CustomModal extends HTMLElement {
      constructor()
      {
        super();

        this.modalContent = this.querySelector('.modalContent')?.content.cloneNode(true);
        this.modal = document.getElementById('customModalTemplate').content.cloneNode(true);

        this.elements = {
          link: this.querySelector('.link'),
          closeButton: this.modal.querySelector('.custom-modal-close'),
          overlay: this.modal.querySelector('.custom-modal-overlay')
        };

        // Events
        this.elements.link.addEventListener('click', this.openModal.bind(this));
        this.elements.closeButton.addEventListener('click', this.closeModal.bind(this));
        this.elements.overlay.addEventListener('click', this.closeModal.bind(this));
      }

      async openModal()
      {

        let htmlString;
        let isDynamic = this.elements.link.classList.contains('dynamic');

        if(isDynamic && this.elements.link.dataset.url){
          htmlString = await this.getDynamicContent(this.elements.link.dataset.url);
        }else{
          const wrapper = document.createElement('div');
          wrapper.appendChild(this.modalContent.cloneNode(true));
          htmlString = wrapper.innerHTML;
        }

        document.body.appendChild(this.modal);
        this.modal = document.getElementById('customModal');
        this.modal.querySelector('.content').innerHTML = htmlString;
        if (isDynamic){
          this.modal.classList.add('dynamic');
        }

        document.documentElement.classList.add('modal-open');
      }

      closeModal()
      {
        this.modal.remove();
        document.documentElement.classList.remove('modal-open');
      }

      async getDynamicContent(dynamicUrl)
      {
        const res = await fetch(dynamicUrl);

        if (!res.ok) {
          throw new Error(`HTTP Error - ${res.status}`);
        }

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const container = doc.querySelector('main');

        if (!container) {
          throw new Error(`main not found : ${dynamicUrl}`);
        }

        return container.innerHTML;
      }
    }
  );
}

